import React, { PureComponent } from "react";
import classnames from "classnames";

import { delay } from "@formant/core/common/delay";
import { fork } from "@formant/core/common/fork";
import { Uuid } from "@formant/core/model/Uuid";

import * as styles from "./DeviceSelector.scss";
import { IconButton } from "./IconButton";

export interface IDeviceSelectorProps {
    selected: Uuid | undefined;
    deviceIds: Uuid[];
    fullscreen?: boolean;
    onSelect: (deviceId: Uuid) => void;
}

export class DeviceSelector extends PureComponent<IDeviceSelectorProps> {
    public render() {
        const { fullscreen } = this.props;
        if (this.index === undefined) {
            fork(this.reset());
        }

        if (this.count <= 1) {
            return false;
        }

        return (
            <div
                className={classnames(
                    styles["device-selector"],
                    fullscreen && styles.fullscreen,
                )}
            >
                <IconButton icon="previous" onClicked={this.onPrevious} />
                {(this.index || 0) + 1} of {this.count}
                <IconButton icon="next" onClicked={this.onNext} />
            </div>
        );
    }

    private get count(): number {
        return this.props.deviceIds.length;
    }

    private get index(): number | undefined {
        const { selected, deviceIds } = this.props;
        const index = selected ? deviceIds.findIndex(_ => selected === _) : -1;
        if (index === -1) {
            return undefined;
        }
        return index;
    }

    private async reset() {
        const { deviceIds, onSelect } = this.props;
        if (deviceIds.length === 0) {
            return;
        }

        await delay();

        onSelect(deviceIds[0]);
    }

    private onNext = () => {
        const { index, count } = this;
        const { deviceIds, onSelect } = this.props;

        onSelect(deviceIds[((index || 0) + 1) % count]);
    };

    private onPrevious = () => {
        const { index, count } = this;
        const { deviceIds, onSelect } = this.props;

        onSelect(deviceIds[((index || 0) + count - 1) % count]);
    };
}
